module.exports = __webpack_public_path__ + "img/eduworks-logo-no-rings.ddeed066.png";